// Project Cash Entries upload template — the client-side sample workbook.
//
// SYNC POINT: the backend parser maps BY HEADER TEXT (row 1). Changing a
// header here means changing the parser too.
//
// Head accepts the labels below (or the codes RA_BILL / ESCALATION /
// SITE_EXPENSE / SALARY). Month accepts 'YYYY-MM' or 'Jul 2026'. Date is
// optional, 'YYYY-MM-DD'. The upload only adds/updates — rows absent from the
// file are never deleted.

export const PROJECT_CASH_TEMPLATE_HEADERS = [
  "Head",
  "Month",
  "Reference No",
  "Date",
  "Amount",
  "Remarks",
];

export const PROJECT_CASH_TEMPLATE_COL_WIDTHS = [
  { wch: 16 },
  { wch: 12 },
  { wch: 18 },
  { wch: 14 },
  { wch: 16 },
  { wch: 40 },
];

/** One example row per head. */
export const PROJECT_CASH_TEMPLATE_SAMPLE_ROWS = [
  ["RA Bill", "2026-07", "RA-07", "2026-07-28", 12500000, "RA bill 7 certified value"],
  ["Escalation", "Jul 2026", "ESC-Q1", "", 450000, "Price variation claim Q1"],
  ["Site Expenses", "2026-07", "", "", 320000, "Site running expenses for the month"],
  ["Salaries", "2026-07", "", "2026-07-31", 1850000, "Staff salaries for July"],
];

export const PROJECT_CASH_TEMPLATE_INSTRUCTIONS = [
  ["Project Cash Entries — Upload Instructions"],
  [""],
  ["Head", "REQUIRED. One of: RA Bill, Escalation, Site Expenses, Salaries (codes RA_BILL, ESCALATION, SITE_EXPENSE, SALARY are also accepted)."],
  ["Month", "REQUIRED. The month the amount belongs to: 2026-07 or Jul 2026."],
  ["Reference No", "Optional. The RA bill number for RA Bill rows, or any reference. Head + Month + Reference No identifies a row: uploading the same combination again UPDATES that entry."],
  ["Date", "Optional. YYYY-MM-DD, e.g. 2026-07-28."],
  ["Amount", "REQUIRED. In rupees, zero or more. Plain number — no commas or currency symbol."],
  ["Remarks", "Optional free text."],
  [""],
  ["Deletes", "The upload only adds and updates entries. Entries not in the file are left as they are — delete them from the screen."],
];
